import React, { useState } from 'react'
import { Button, ButtonText } from '../ui/button'
import { ArchiveBoxIcon } from '@heroicons/react/24/solid'
import usePrearchiveVault from '@/services/api/vault/usePrearchiveVault'
import ArchiveVault from './ArchiveVault'
import ArchiveEmptyVault from './ArchiveEmptyVault'

type Props = {
  vault: { id: number; name: string }
}

export default function ArchiveVaultButton({ vault }: Props) {
  const { action: prearchiveVault, status: prearchiveVaultStatus } =
    usePrearchiveVault()

  const ACTION_TYPES = {
    ARCHIVE_VAULT_EMPTY: 'emptyVault',
    ARCHIVE_VAULT: 'archiveVault',
  }

  const [actionType, setActionType] = useState(null)

  async function prearchive() {
    const response = await prearchiveVault({ id: vault.id })
    console.log(response)

    if (
      response?.can_delete &&
      !(response?.requires_expense_default || response?.requires_income_default)
    ) {
      setActionType(ACTION_TYPES.ARCHIVE_VAULT_EMPTY)
      console.log('empty vault')
      //   openModal({ name: MODAL_WINDOW_TYPE.EMPTY_VAULT_ARCHIVE })
    } else {
      setActionType(ACTION_TYPES.ARCHIVE_VAULT)
      console.log('archive vault')
      //   openModal({ name: MODAL_WINDOW_TYPE.ARCHIVE_VAULT })
    }
  }

  return (
    <>
      {actionType === ACTION_TYPES.ARCHIVE_VAULT && (
        <ArchiveVault vault={vault} />
      )}

      {actionType === ACTION_TYPES.ARCHIVE_VAULT_EMPTY && (
        <ArchiveEmptyVault vault={vault} />
      )}
      <Button
        disabled={prearchiveVaultStatus.status === 'pending'}
        loading={prearchiveVaultStatus.status === 'pending'}
        variant="destructiveGhost"
        onClick={prearchive}
        className={'w-full justify-start'}
      >
        <ArchiveBoxIcon />
        <ButtonText>Archive</ButtonText>
      </Button>
    </>
  )
}
